import clsx from 'clsx';

const DEFAULT_TEXT = 'No data available';

interface DataProps {
  className?: string;
  text?: string;
}

export const NoData = (props: DataProps) => {
  const text = props.text || DEFAULT_TEXT;

  return <div className={clsx('items-center my-auto dark:text-ice flex justify-center p-6 text-slate', props.className)}>{text}</div>;
};
